import type { IconSvgObject } from './types';

const HugeiconsIcon: IconSvgObject = [
  ["path", { d: "M2 9.5H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5 9.5H3.5L4.67151 18.8721C4.85917 20.3734 6.13538 21.5 7.64835 21.5H16.3517C17.8646 21.5 19.1408 20.3734 19.3285 18.8721L20.5 9.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 9C5 5.41015 8.13401 2.5 12 2.5C15.866 2.5 19 5.41015 19 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default HugeiconsIcon;
